/**
 * Arc prototype visual language.
 *
 * Rules:
 * - Status colors mean only status: good / caution / bad
 * - Interaction blue means selection / focus / active state
 * - Targets are reference guides, not status
 * - Structure stays neutral
 */

export const ARC_STATUS = {
  good: {
    color: '#16A34A',
    textClass: 'text-rowing-green',
    bgClass: 'bg-rowing-green',
    softBgClass: 'bg-rowing-green/10',
    softBorderClass: 'border-rowing-green/30',
    fillClass: 'bg-rowing-green/70',
  },
  caution: {
    color: '#EAB308',
    textClass: 'text-rowing-yellow',
    bgClass: 'bg-rowing-yellow',
    softBgClass: 'bg-rowing-yellow/10',
    softBorderClass: 'border-rowing-yellow/35',
    fillClass: 'bg-rowing-yellow/70',
  },
  bad: {
    color: '#DC2626',
    textClass: 'text-rowing-red',
    bgClass: 'bg-rowing-red',
    softBgClass: 'bg-rowing-red/10',
    softBorderClass: 'border-rowing-red/30',
    fillClass: 'bg-rowing-red/70',
  },
  na: {
    color: '#9CA3AF',
    textClass: 'text-rowing-gray-500',
    bgClass: 'bg-rowing-gray-400',
    softBgClass: 'bg-rowing-gray-100',
    softBorderClass: 'border-rowing-gray-200',
    fillClass: 'bg-rowing-gray-400/70',
  },
} as const;

export const ARC_INTERACTION = {
  activeColor: '#1E40AF',
  activeTextClass: 'text-accent',
  activeBgClass: 'bg-accent',
  activeSoftBgClass: 'bg-accent/10',
  activeBorderClass: 'border-accent',
  activeRingClass: 'ring-2 ring-accent ring-offset-0',
} as const;

export const ARC_TARGET = {
  line: {
    catchGap: {
      color: '#DC2626',
      lineClass: 'bg-rowing-red',
      borderClass: 'border-rowing-red',
    },
  },
  band: {
    effectiveLength: {
      color: '#16A34A',
      bgClass: 'bg-rowing-green/20',
      borderClass: 'border-rowing-green',
      lineClass: 'border-rowing-green',
    },
    finishSlip: {
      color: '#EAB308',
      bgClass: 'bg-rowing-yellow/20',
      borderClass: 'border-rowing-yellow',
      lineClass: 'border-rowing-yellow',
    },
  },
} as const;

export const ARC_STRUCTURE = {
  neutralBarClass: 'bg-gradient-to-t from-rowing-gray-500/90 to-rowing-gray-400/75',
} as const;

export const getStatusTextClass = (status: keyof typeof ARC_STATUS) => ARC_STATUS[status].textClass;
export const getStatusFillClass = (status: keyof typeof ARC_STATUS) => ARC_STATUS[status].fillClass;
export const getStatusBgClass = (status: keyof typeof ARC_STATUS) => ARC_STATUS[status].bgClass;
